
<div  class="search-popup" >
  
  <button *ngIf="this.searchVariable" class="button" style="float: right;
  border: none;
  background: transparent;">
    <mat-icon class="menu-button" (click)="clear()">X</mat-icon>
  </button>
    <form >
      <input type="text" (keyup)="searchblog($event)" [(ngModel)]="searchVariable"  [ngModelOptions]="{standalone: true}" autocomplete="off" tabindex="-1" placeholder="Search..">
    </form>
    <div *ngIf="searchdata?.length>0 && this.searchVariable">
      <div *ngFor="let datas of searchdata">
        <a href="{{datas.url}}"><p>{{datas.title}}</p></a>
      </div>
    </div>
   
</div>